/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ServiceAccueil.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';
import $ from 'jquery';
import HeightMatchingGroup from 'react-height-matching-group';

let boundItemClick = [];

@withStyles(s)
export default class ServiceAccueil extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            services: []
        };

    }
    
    componentDidMount(){
        this.GetServices();
        
    }

    async GetServices() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{services{id, slug, title, content, titleHover, contentHover, lienPage}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.services) throw new Error('Erreur sur le chargement des services !');

        this.setState({ services: data.services })
        
    }


    render(){


        return (
            <div className={s.root}>
                <div className={`servicesAccueil`}>
                    <ul>
                        {this.state.services.map((item, index) => (
                        <li key={index} className={`blocService`}>
                            <div className={`box`}>
                                <div className={`boxInside`}>
                                    <div className={`content`}>
                                        <span className={`titreServiceAccueil`}>{item.title}</span>
                                        <span className={`texteServiceAccueil`} dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <span className={`wrapPlus`}>
                                            <span className={`carre`}><i className={`fa fa-plus`}></i></span>
                                        </span>
                                    </div>
                                </div>
                                <div className={`boxInsideHover`}>
                                    <Link to={`/${item.slug}`}>
                                        <div className={`content`}>
                                            <span className={`titreServiceAccueilHover`}>{item.titleHover}</span>
                                            <span className={`texteServiceAccueilHover`} dangerouslySetInnerHTML={{ __html: item.contentHover }} />
                                            <div className={`btnSite`}>
                                                <span>En savoir plus</span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/ServiceAccueil/ServiceAccueil.js